import gsap from 'gsap';
import CustomEase from 'gsap/CustomEase';

// Custom Ease
gsap.registerPlugin(CustomEase);
CustomEase.create("move-1", "M0,0 C0.178,0.73 0.128,0.584 0.23,0.796 0.256,0.85 0.304,0.938 1,1 ")

class Modals {
  constructor() {
    this.buttons = document.querySelectorAll('.js-modal-button');
    this.closeGeneral = `<a href="#" class="close-modal js-close-modal" data-close="general-modal">
    <svg width="25" height="26" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.57907 9.14465L13.5757 15.1413L14.9899 13.7271L8.99329 7.73044L14.9901 1.73367L13.5758 0.319458L7.57907 6.31622L1.58218 0.319336L0.167969 1.73355L6.16486 7.73044L0.168111 13.7272L1.58232 15.1414L7.57907 9.14465Z" fill="#333333"></path>
    </svg>
  </a>`;
    this.init();

    // Can add youtube script to footer - commented out
    // this.appendThirdPartyScripts();
  }

  init() {
    // Buttons to open modal
    this.buttons.forEach(button => {
      button.addEventListener('click', event => { this.openModal(event) });
    })

    // Listens for close modals element to trigger modal close
    document.addEventListener('click', event => {
      if (event.target.matches('.js-close-modal')) {
        this.closeModal(event)
      }
    })
  }

  // Open general and video modals
  openModal(event, _contentId, _modalId, _contentWidth) {

    window.smooth.off()

    if (window.innerWidth <= 1024) {
      document.documentElement.classList.add('of-h')
      document.body.classList.add('of-h')
    }

    // Gather datasets
    let contentId, modalId, modal;

    if (event != undefined) {
      event.preventDefault();

      contentId = event.target.dataset.contentId;
      modalId = event.target.dataset.modal;
    } else if (event == undefined) {
      contentId = _contentId;
      modalId = _modalId;
    }

    // Get modal information - depending on gneral or video
    if (modalId == 'general-modal' || modalId == 'general-modal-two' ) {
      modal = new Object;
      modal.el = document.querySelector(`#${modalId}`);

      if (event != undefined) {
        modal.contentWidth = event.target.dataset.contentWidth;
        modal.contentHTML = document.querySelector(`.modal-content-wrapper #${contentId}`);
      } else if (event == undefined) {
        modal.contentWidth = _contentWidth;
        modal.contentHTML = document.querySelector(`.modal-content-wrapper #${contentId}`);
      }

      // Open modal
      this.openGeneralModal(event, modal)
    }
    else if (modalId == 'general-video') {
      modal = new Object;
      modal.el = document.querySelector(`#${modalId}`);

      if (event != undefined) {
        modal.contentWidth = event.target.dataset.contentWidth;
        modal.videoId = event.target.dataset.contentId;
      } else if (event == undefined) {
        modal.contentWidth = _contentWidth;
        modal.videoId = contentId;
      }

      // Open modal
      this.openVideoModal(event,modal);
    }
  }

  // Close general and video modals
  closeModal(event) {
    event.preventDefault();

    if (window.innerWidth <= 1024) {
      document.documentElement.classList.remove('of-h')
      document.body.classList.remove('of-h')
    }

    // Find modals
    let modalId, modal, contentHTML;
    modalId = event.target.dataset.close;
    modal = document.querySelector(`#${modalId}`);

    if (modalId == "general-modal") {
      contentHTML = modal.querySelector('.content-inner');
    } else if (modalId == "general-video") {
      contentHTML = modal.querySelector('.video-col');
    }


    let tl = gsap.timeline();

    // Animate modal out
    tl.to(contentHTML, {
      duration: 0.6,
      alpha: 0,
      y: -20,
      ease: "move-1",
    })
    tl.to(modal, {
      duration: 0.6,
      alpha: 0,
      ease: "move-1",
      onComplete: () => {
        modal.classList.remove('active');
        // document.body.style.overflow = ''

        // Reset modal content
        this.resetModal(modalId);

        // prevent scroll on body - animsiiton is dumb so that's why it's commented out
        // document.body.classList.remove('of-h');
        // document.querySelector('.animsition').style.pointerEvents = 'all'
        window.smooth.on()
      },
    }, '-=0.4')
  }

  // Resets modal for next use
  resetModal(modalId) {
    if (modalId == 'general-modal') {
      let modal = document.querySelector(`#${modalId}`);

      let contentHTML = modal.querySelector('.content-inner');
      contentHTML.classList = 'content-inner';
      contentHTML.innerHTML = '';
    }
    else if (modalId == 'general-modal-two') {
      let modal = document.querySelector(`#${modalId}`);

      let contentHTML = modal.querySelector('.content-inner');
      contentHTML.classList = 'content-inner';
      // contentHTML.innerHTML = '';
      modal.querySelector('.scroll-wrapper').innerHTML = ''

    }
    else if (modalId == 'general-video') {
      let modal = document.querySelector(`#${modalId}`);

      let contentHTML = modal.querySelector('.video-col');
      contentHTML.classList = 'video-col';

      // Create new element for youtube iframe
      let player = modal.querySelector('#player');
      player.remove();
      let newPLayer = document.createElement('div');
      newPLayer.id = "player";

      contentHTML.append(newPLayer);
    }
  }

  openGeneralModal(event, modal) {
    modal.el.content = modal.el.querySelector('.content-inner');
    modal.el.content.classList = 'content-inner ' + modal.contentWidth;

    // document.body.style.overflow = 'hidden'

    // Clone content
    let newContent = modal.contentHTML.cloneNode(true);

    if (modal.el.id != 'general-modal-two') {
      // Fill modal with cloned content
      modal.el.content.innerHTML = this.closeGeneral + newContent.innerHTML;
    } else if (modal.el.id == 'general-modal-two') {
      modal.el.querySelector('.scroll-wrapper').innerHTML = newContent.innerHTML;
    }

    // Make modal active
    modal.el.classList.add('active');

    // prevent scroll on body - animsiiton is dumb so that's why it's commented out
    // document.body.classList.add('of-h');
    // document.querySelector('.animsition').style.pointerEvents = 'none'
    window.smooth.off()

    let tl = gsap.timeline();

    // Animate modal in
    tl.to(modal.el, {
      delay: 0.3,
      duration: 0.6,
      alpha: 1,
      ease: "move-1",
    })
    tl.to(modal.el.content, {
      duration: 0.6,
      alpha: 1,
      y: 0,
      ease: "move-1",
    }, '-=0.4')
  }

  openVideoModal(event, modal) {
    modal.el.content = modal.el.querySelector('.video-col');
    modal.el.content.classList = 'video-col ' + modal.contentWidth;

    // Use embed id to add iframe for youtube video
    // eslint-disable-next-line
    let player = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: modal.videoId,
        events: {
          'onReady': this.onPlayerReady,
        },
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
        },
      });

    // Make modal active
    modal.el.classList.add('active');

    // prevent scroll on body - animsiiton is dumb so that's why it's commented out
    // document.body.classList.add('of-h');
    // document.querySelector('.animsition').style.pointerEvents = 'none'
    window.smooth.off()

    if (window.innerWidth <= 1024) {
      document.documentElement.classList.remove('of-h')
      document.body.classList.remove('of-h')
    }

    let tl = gsap.timeline();

    // Animate modal in
    tl.to(modal.el, {
      delay: 0.3,
      duration: 0.6,
      alpha: 1,
      ease: "move-1",
    })
    tl.to(modal.el.content, {
      duration: 0.6,
      alpha: 1,
      y: 0,
      ease: "move-1",
    }, '-=0.4')

    /* eslint-disable */

     // 4. The API will call this function when the video player is ready.
     function onPlayerReady(event) {
      if (window.innerWidth > 1024) {
        event.target.playVideo();
      } else if (window.innerWidth < 1025) {
        event.target.mute();
        event.target.playVideo();

        // Get around mobile muted issues
        setTimeout(() => {
          event.target.unMute();
        }, 2000)
      }
    }

    // 5. The API calls this function when the player's state changes.
    //    The function indicates that when playing a video (state=1),
    //    the player should play for six seconds and then stop.
    // var done = false;
    function onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING && !done) {
        setTimeout(stopVideo, 6000);
        done = true;
      }
    }
    function stopVideo() {
      player.stopVideo();
    }
  }

  /*
  appendThirdPartyScripts() {
    // Only if not first page load
    if (window.history.state.index < 1) {
      setTimeout(() => {
        let pageWrap = document.querySelector('.content.wrap');

        let scripts = [
          'https://www.youtube.com/iframe_api',
        ];

        for(let a = 0; a < scripts.length; a++) {
          let newScript = document.createElement('script');
          newScript.setAttribute('src', scripts[a]);
          newScript.setAttribute('defer', '');
          pageWrap.append(newScript);
        }
      }, 1600)
    }
  }
  */
}
export default Modals;



// WEBPACK FOOTER //
// ./scripts/routes/components/Modals.js